/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Commission_SubtitleInputs */



/**
* | output |
* | --- |
* | "Your commission earnings and attributed customers." |
*
* @param {Partner_Commission_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_commission_subtitle = /** @type {((inputs?: Partner_Commission_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Commission_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Deine Provisionseinnahmen und zugeordneten Kunden.")
	return /** @type {LocalizedString} */ ("Your commission earnings and attributed customers.")
});